import { createFileRoute, Outlet } from "@tanstack/react-router";
import { AppShell } from "@/components/layout/app-shell";
import { AccountGate } from "@/features/accounts/gate";

export const Route = createFileRoute("/_app")({
  component: () => (
    <AccountGate>
      <AppShell>
        <Outlet />
      </AppShell>
    </AccountGate>
  ),
});
